import { SurgicalHistoryControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useArchivePatientSurgicalHistory = () =>
  useMutationWithLoading(
    async (param: {
      patientSurgicalHistoryId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new SurgicalHistoryControllerApi(
        getConfigObject()
      ).updatePatientSurgicalHistoryArchiveStatus(
        param.patientSurgicalHistoryId,
        param.status,
        param.xTENANTID //xTENANTID
      )
  );
